import React from 'react';
import VehicleForm from './components/VehicleForm';

const VehicleEditPage: React.FC = () => {
  // Title is set at the application level
  return <VehicleForm isEdit={true} />;
};

export default VehicleEditPage;